import React, { Fragment } from "react";
import moment from "moment-timezone";

import { getText, getTimeDuration } from "../../helpers";

export default function InspectionsTable(props) {
  let { inspections } = props;

  return (
    <table className="inspections-table">
      <thead>
        <tr>
          <th>{getText("Created")}</th>
          <th>{getText("Completed")}</th>
          <th>{getText("Inspection Owner")}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {inspections.map((inspection, i) => {
          const { safetyculture_inspection_id, created_at, completed_date, archived_date, owner } = inspection;
          const { first_name, last_name, email } = JSON.parse(owner);
          const inspectionOwner = `${first_name} ${last_name} (${email})`;
          const createdAtMoment = created_at && moment(created_at);
          const completedAtMoment = completed_date && moment(completed_date);
          const createdAtStr = createdAtMoment && createdAtMoment.format("DD MMM YYYY hh:mm A");
          const completedAtStr = completedAtMoment ? completedAtMoment.format("DD MMM YYYY hh:mm A") : getText("Not Completed");
          const archivedDateStr = archived_date && moment(archived_date).format("DD MMM YYYY");

          const createdTimeDuration = getTimeDuration(createdAtMoment);
          const completedTimeDuration = getTimeDuration(completedAtMoment);

          return (
            <tr>
              <td>
                <Fragment>
                  <div>
                    {createdAtStr} {createdTimeDuration && `(${createdTimeDuration})`}
                  </div>
                  {archivedDateStr && (
                    <div className="archived-inspections">
                      {getText("Archived")} ({archivedDateStr})
                    </div>
                  )}
                </Fragment>
              </td>
              <td>
                {completedAtStr} {completedTimeDuration && `(${completedTimeDuration})`}
              </td>
              <td>{inspectionOwner}</td>
              <td>
                <a
                  className="inspection-details-popup-content-link"
                  href={`https://app.safetyculture.com/inspection/${safetyculture_inspection_id}`}
                  target="_blank"
                >
                  {getText("View Inspection")}
                </a>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}



// WEBPACK FOOTER //
// ./src/components/create_inspection_link/inspection_table.js